import { Helmet } from "react-helmet";
import * as gl from "GlobalConfig";

const HelmetComponent = () => {
  if (!gl.UmamiScript && !gl.UmamiID) {
    return null;
  }

  return (
    <Helmet>
      <script
        defer
        src={gl.UmamiScript}
        data-website-id={gl.UmamiID}
      />
    </Helmet>
  );
};

export default HelmetComponent;